import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {SymbolStates} from "../../../reels/symbols/BasicSymbol";
import {SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";
import {XWaySymbol} from "../../../reels/symbols/XWaySymbol";
import {XSplitSymbol} from "../../../reels/symbols/XSplitSymbol";
import {ScatterSymbol} from "../../../reels/symbols/ScatterSymbol";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class StickyUnlockPresentation implements SimplePresentation {
    name: string = "StickyUnlockPresentation";
    private _unlockTl: gsap.core.Timeline;
    private skipped: boolean = false;

    shouldRun(): boolean {
        return XwaysHoarder2.model.data.mode === GameMode.FREESPIN || XwaysHoarder2.model.data.mode === XW2GameMode.SUPER_FREESPIN || XwaysHoarder2.model.gameData.thisRespinIsTheLastReSpinReSpin;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._unlockTl = gsap.timeline({
            onComplete: () => {
                [0, 1, 2, 3, 4, 5].forEach((reelNo: number) => {
                    XwaysHoarder2.reelView.reels[reelNo].model.xsplitArray = [];
                    XwaysHoarder2.reelView.reels[reelNo].model.xwaysArray = [];
                    XwaysHoarder2.reelView.reels[reelNo].model.scatterArray = [];
                })
                controller.setSkipCallback();
                controller.finish();
            }
        });

        let unlockSoundPlayed: boolean = false;
        [0, 1, 2, 3, 4, 5].forEach((reelNo: number) => {
            const checkXWArray: SimpleReelModelSymbolData[] = XwaysHoarder2.reelView.reels[reelNo].model.xwaysArray;
            const checkXSArray: SimpleReelModelSymbolData[] = XwaysHoarder2.reelView.reels[reelNo].model.xsplitArray;
            const checkSCArray: SimpleReelModelSymbolData[] = XwaysHoarder2.reelView.reels[reelNo].model.scatterArray;
            checkXWArray.forEach((item: SimpleReelModelSymbolData) => {
                this._unlockTl.add((<XWaySymbol>item.positionable).getStateAnimation(SymbolStates.UNSTICKY), 0);
                if(!unlockSoundPlayed) {
                    this._unlockTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_OFF);
                    }, "<");
                    unlockSoundPlayed = true;
                }
            })
            checkXSArray.forEach((item: SimpleReelModelSymbolData) => {
                this._unlockTl.add((<XSplitSymbol>item.positionable).getStateAnimation(SymbolStates.UNSTICKY), 0);
                if(!unlockSoundPlayed) {
                    this._unlockTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_OFF);
                    }, "<");
                    unlockSoundPlayed = true;
                }
            })
            checkSCArray.forEach((item: SimpleReelModelSymbolData) => {
                this._unlockTl.add((<ScatterSymbol>item.positionable).getStateAnimation(SymbolStates.UNSTICKY), 0);
                if(!unlockSoundPlayed) {
                    this._unlockTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_OFF);
                    }, "<");
                    unlockSoundPlayed = true;
                }
            })

        });
        this._unlockTl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
        }, 0);

    }

    private onSkip(): void {
        this._unlockTl.totalProgress(1);
    }


}